import { REST, AFSP } from 'utils/reqUtils';
import { FORM } from 'utils/formUtils';

const
{ STATUS } = REST,
{ TYPES } = FORM;

var defaultRequest = {
    status: STATUS.NONE,
    code: null,
    error: null,
    data: null
}

export const stateConfig = {
    // [ABOUT]
    // +-{ REQ }-+--{ PROP }--+-{ DATA TYPE }-+-----------------------{ DESC }-----------------------+
    // | true    | ref        | string        | The name of the 'this.state[ref]' in state.          |
    // +---------+------------+---------------+------------------------------------------------------+
    // | false   | validation | array of      | The validation steps required for a field. Options:  |
    // |         |            | objects       | 'alphabetic', 'alphanumeric', 'date', 'phone',       |
    // |         |            |               | 'past', 'future'.                                    |
    // +---------+------------+---------------+------------------------------------------------------+
    // | false   | required   | boolean       | By default, if not used, 'required' is 'true'. Only  |
    // |         |            |               | add it to make it 'false'.                           |
    // +---------+------------+---------------+------------------------------------------------------+
    // | false   | mod        | string        | This string represents a function call that should   |
    // |         |            |               | be used to sanitize any input an object with this    |
    // |         |            |               | property has.                                        |
    // +---------+------------+---------------+------------------------------------------------------+

    login: {
        login: {
            candidate: [
                { ref: TYPES.USER_ID },
                { ref: TYPES.PASSWORD }
            ],
            provider: []
        },
        forgotten: {
            candidate: [
                { ref: TYPES.USER_ID, validation: [ 'alphanumeric|email' ] },
                { ref: TYPES.CAPTCHA }
            ],
            provider: []
        },
        changeEmail: {
            candidate: [
                { ref: TYPES.USER_ID, validation: [ 'alphanumeric|email' ] },
                { ref: TYPES.EMAIL_ADDRESS, validation: [ 'email' ] },
                { ref: TYPES.VERIFY_EMAIL_ADDRESS, validation: [ 'email' ] },
                { ref: TYPES.PASSPORT_NUMBER, required: false, validation: [ 'alphanumeric' ] },
                { ref: TYPES.ISSUING_COUNTRY, required: false },
                { ref: TYPES.CITY_BORN, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_FOOD, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_COLOR, validation: [ 'name' ] },
                { ref: TYPES.CAPTCHA }
            ],
            provider: []
        }
    },
    registration: {
        personal: {
            candidate: [
                { ref: TYPES.FIRST_GIVEN_NAME, validation: [ 'name' ] },
                { ref: TYPES.MIDDLE_NAME, required: false, validation: [ 'name' ] },
                { ref: TYPES.LAST_FAMILY_SURNAME, validation: [ 'name' ] },
                { ref: TYPES.NAME_SUFFIX, required: false },
                { ref: TYPES.DATE_OF_BIRTH, validation: [ 'past' ] },
                { ref: TYPES.DATE_OF_BIRTH_IS },
                { ref: TYPES.PHONE_NUMBER, validation: [ 'phone' ] }
            ],
            provider: [
                { ref: TYPES.FIRST_GIVEN_NAME, validation: [ 'name' ] },
                { ref: TYPES.MIDDLE_NAME, required: false, validation: [ 'name' ] },
                { ref: TYPES.LAST_FAMILY_SURNAME, validation: [ 'name' ] },
                { ref: TYPES.PHONE_NUMBER, validation: [ 'phone' ] },
                {
                    ref: TYPES.EMAIL_ADDRESS,
                    validation: [ 'email' ],
                    async: {
                        active: true,
                        help: {
                            pending: '',
                            _404: '',
                        },
                        stateRef: 'registration.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.EMAIL
                    },
                    link: [ TYPES.VERIFY_EMAIL_ADDRESS ]
                },
                { ref: TYPES.VERIFY_EMAIL_ADDRESS, validation: [ 'email' ], link: [ TYPES.EMAIL_ADDRESS ] },
                { ref: TYPES.FSDO, required: false },
                { ref: TYPES.PROVIDER_NAME, required: false },
                { ref: TYPES.PROVIDER_STATE, required: false },
                { ref: TYPES.PROVIDER_TYPE, required: false },
                { ref: TYPES.CERT_DESIGNATOR, validation: [ 'name' ] },
                { ref: TYPES.CONSENT, required: true }
            ]
        },//
        passport: {
            candidate: [
                { ref: TYPES.PASSPORT_TYPE },
                { ref: TYPES.PASSPORT_NUMBER, validation: [ 'alphanumeric' ] },
                { ref: TYPES.ISSUE_DATE, validation: [ 'past' ] },
                { ref: TYPES.EXPIRATION_DATE, required: false, validation: [ 'future' ] },
                { ref: TYPES.ISSUING_COUNTRY },
                { ref: TYPES.CITY, validation: [ 'name' ] }
            ],
            provider: []
        },
        email: {
            candidate: [
                {
                    ref: TYPES.USER_ID,
                    minLength: 3,
                    validation: [ 'alphanumeric' ],
                    async: {
                        active: false,
                        help: {
                            pending: '',
                            _200: 'Already exists. Choose another.',
                            _404: ''
                        },
                        stateRef: 'registration.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.USERNAME
                    }
                },
                {
                    ref: TYPES.EMAIL_ADDRESS,
                    validation: [ 'email' ],
                    async: {
                        active: false,
                        help: {
                            pending: '',
                            _200: 'Already exists. Choose another.',
                            _404: '',
                        },
                        stateRef: 'registration.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.EMAIL
                    },
                    link: [ TYPES.VERIFY_EMAIL_ADDRESS ]
                },
                { ref: TYPES.VERIFY_EMAIL_ADDRESS, validation: [ 'email' ], link: [ TYPES.EMAIL_ADDRESS ] }
            ],
            provider: []
        },
        security: {
            candidate: [
                { ref: TYPES.CITY_BORN, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_FOOD, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_COLOR, validation: [ 'name' ] }
            ],
            provider: []
        },
        signature: {
            candidate: [
                { ref: TYPES.UNDERSTAND_AND_AGREE },
                { ref: TYPES.FULL_NAME, validation: [ 'name' ] },
                { ref: TYPES.VERFICATION_CODE, validation: [ 'alphanumeric' ] }
            ],
            provider: []
        },
        submit: {
            candidate: [
                { ref: TYPES.CAPTCHA, minLength: 8, validation: [ 'alphanumeric' ] }
            ]
        }
    },
    recovery: {
        personal: {
            candidate: [
                { ref: TYPES.FIRST_GIVEN_NAME, validation: [ 'name' ] },
                { ref: TYPES.MIDDLE_NAME, required: false, validation: [ 'name' ] },
                { ref: TYPES.LAST_FAMILY_SURNAME, validation: [ 'name' ] },
                { ref: TYPES.NAME_SUFFIX, required: false },
                { ref: TYPES.DATE_OF_BIRTH, validation: [ 'past' ] },
                { ref: TYPES.DATE_OF_BIRTH_IS },
                { ref: TYPES.PHONE_NUMBER, validation: [ 'phone' ] }
            ],
        },
        passport: {
            candidate: [
                { ref: TYPES.PASSPORT_TYPE },
                { ref: TYPES.PASSPORT_NUMBER, validation: [ 'alphanumeric' ] },
                { ref: TYPES.ISSUE_DATE, validation: [ 'past' ] },
                { ref: TYPES.EXPIRATION_DATE, required: false, validation: [ 'future' ] },
                { ref: TYPES.ISSUING_COUNTRY },
                { ref: TYPES.CITY, validation: [ 'name' ] }
            ],
            provider: []
        },
        email: {
            candidate: [
                {
                    ref: TYPES.USER_ID,
                    minLength: 3,
                    validation: [ 'alphanumeric' ],
                    async: {
                        active: false,
                        help: {
                            pending: '',
                            _200: 'Already exists. Choose another.',
                            _404: ''
                        },
                        stateRef: 'recovery.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.USERNAME
                    }
                },
                {
                    ref: TYPES.OLD_EMAIL_ADDRESS,
                    validation: [ 'email' ],
                    async: {
                        active: false,
                        help: {
                            pending: '',
                            _200: 'Already exists. Choose another.',
                            _404: '',
                        },
                        stateRef: 'recovery.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.EMAIL
                    },
                    link: [ TYPES.VERIFY_EMAIL_ADDRESS ]
                },
                {
                    ref: TYPES.NEW_EMAIL_ADDRESS,
                    validation: [ 'email' ],
                    async: {
                        active: false,
                        help: {
                            pending: '',
                            _200: 'Already exists. Choose another.',
                            _404: '',
                        },
                        stateRef: 'recovery.email',
                        request: AFSP.TYPE.CHECK,
                        type: AFSP.CHECK_TYPE.EMAIL
                    },
                    link: [ TYPES.VERIFY_EMAIL_ADDRESS ]
                },
                { ref: TYPES.VERIFY_EMAIL_ADDRESS, validation: [ 'email' ], link: [ TYPES.EMAIL_ADDRESS ] }
            ],
            provider: []
        },
        security: {
            candidate: [
                { ref: TYPES.CITY_BORN, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_FOOD, validation: [ 'name' ] },
                { ref: TYPES.FAVORITE_COLOR, validation: [ 'name' ] }
            ],
            provider: []
        },
        signature: {
            candidate: [
                { ref: TYPES.UNDERSTAND_AND_AGREE },
                { ref: TYPES.FULL_NAME, validation: [ 'name' ] },
                { ref: TYPES.VERFICATION_CODE, validation: [ 'alphanumeric' ] }
            ],
            provider: []
        },
        submit: {
            candidate: [
                { ref: TYPES.CAPTCHA, minLength: 8, validation: [ 'alphanumeric' ] }
            ]
        }
    },
    request: {
        registration: defaultRequest,
        home: {
            login: defaultRequest,
            forgot: defaultRequest,
            change: defaultRequest,
            reset: defaultRequest
        },
        captcha: defaultRequest,
        captchaValidation: defaultRequest,
        check: defaultRequest
    }
}
